const arr = [
    // 发券中心
    {
        path: '/coupon/center',
        component: () => import(/* webpackChunkName:"coupon-center"*/ '@/pages/coupon/couponCenter/index.vue'),
        name: 'couponCenter',
        meta: {
            title: '领券中心',
        },
    },
];
export default arr;
